import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';

@Component({
    selector: 'aa-chips-switch',
    templateUrl: './chips-switch.component.html',
    styleUrls: [
        './chips-switch.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipsSwitchComponent
{
    public chipsState: Observable<boolean> = of(false);

    constructor (private store: Store<IAuroraState>)
    {
        this.chipsState = this.store.select(fromRootStore.getChipsStatus);
    }

    public onToggleShowChips (chipsState: boolean)
    {
        this.store.dispatch(fromRootStore.RootMiscStoreActions.RootToggleShowChips({ chipsState }));
    }
}
